import { render, staticRenderFns } from "./BaseAddElement.vue?vue&type=template&id=5f31b00a"
import script from "./BaseAddElement.vue?vue&type=script&lang=js"
export * from "./BaseAddElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports